<sbw-popup2 [heading]="'PASSENGERS_SELECT_ADDRESS_TITLE' | resource:'Passengers'" [closable]="true" (closing)="close()">
    <form [formGroup]="findAddressForm">
        <div>
            <p>{{'PASSENGERS_SELECT_ADDRESS' | resource:'Passengers'}}</p>
            <div class="column small-12 addresses-container">
                <div class="row">
                    <div class="column small-12 field" *ngFor="let searchResult of model.addresses; let index = index;">
                        <input type="radio" formControlName="address" name="address" id="address_{{index}}"
                            [value]="searchResult.moniker">
                        <label class="address-label" for="address_{{index}}">{{searchResult.partialAddress}}</label>
                    </div>
                </div>
            </div>
            <div class="column small-12 medium-6 medium-push-6 large-4 large-push-8 field submit">
                <a class="preferred-action" (click)="continue()"> {{'CONTINUE' | resource:'Common'}}</a>
            </div>
        </div>
    </form>
</sbw-popup2>
